import { ChangeDetectionStrategy, Component, forwardRef } from '@angular/core';
import { TypeaheadDropdownInputComponent } from '../../form-components/typeahead-dropdown-input/typeahead-dropdown-input.component';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-member-table-typeahead-dropdown',
  templateUrl: '../../form-components/typeahead-dropdown-input/typeahead-dropdown-input.component.html',
  styleUrls: ['../member-table-input.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MemberTableTypeaheadDropdownComponent),
      multi: true
    }
  ],
  changeDetection: ChangeDetectionStrategy.Default
})
export class MemberTableTypeaheadDropdownComponent extends TypeaheadDropdownInputComponent {}
